module.exports = __webpack_public_path__ + "img/9.95b851cd.jpg";